module.exports = __webpack_public_path__ + "static/media/patient_icon.ba866146.svg";